import {
  Directive,
  effect,
  ElementRef,
  inject,
  input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { UserService } from '@shared/services/user.service';
import {IRole} from "@shared/interfaces/role.interface";

@Directive({
  selector: '[pwjHasAccess]',
  standalone: true,
})
export class HasAccessDirective implements OnDestroy {
  private _hasView = false;
  // inputs
  pwjHasAccess = input<string | readonly string[]>('');

  // dependencies
  private readonly _templateRef = inject(TemplateRef<ElementRef>);
  private readonly _viewContainerRef = inject(ViewContainerRef);
  private readonly _userService = inject(UserService);

  constructor() {
    effect(() => {
      const userRoles = this._userService.userSignal()?.roles ?? [];
      const hasAccess = this.checkAccess(userRoles);

      if (hasAccess && !this._hasView) {
        this._viewContainerRef.clear();
        this._viewContainerRef.createEmbeddedView(this._templateRef);
        this._hasView = true;
      } else if (!hasAccess && this._hasView) {
        this._viewContainerRef.clear();
        this._hasView = false;
      }
    });
  }

  private checkAccess(roles: IRole[]): boolean {
    const accessValue = this.pwjHasAccess();
    if (!accessValue) return false;

    if (typeof accessValue === 'string') {
      return accessValue === 'OK';
    }

    return roles.some(role => accessValue.includes(role.title));
  }

  ngOnDestroy() {
    if (this._hasView) {
      this._viewContainerRef.clear();
      this._hasView = false;
    }
  }
}
